// `https://6db245b4241642aa91128d08c2ce26f3@sentry.prismacloud.cc/16` gets replaced during buildtime by envsubst
export const BUILD_SENTRY_DSN = 'https://6db245b4241642aa91128d08c2ce26f3@sentry.prismacloud.cc/16'.includes('SENTRY_DSN')
  ? ''
  : 'https://6db245b4241642aa91128d08c2ce26f3@sentry.prismacloud.cc/16';
